module.exports = __webpack_public_path__ + "static/desktop2-387ace8e9024f1b621739a68e70a024b.png";